import React from "react";
import ReverLogo from "../assets/img/rever.png";
import { ArrowRight } from "lucide-react";
import AppConstant from "../assets/js/AppConstant";

const TerminateStaticWebLanding = () => {
  return (
    <>
      <div className="w-full min-h-screen bg-black text-white">
        <div className="flex flex-col h-screen w-full items-center justify-center space-y-12">
          <img src={ReverLogo} alt="ReverLogo" width={720} />
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl text-center">
              ระบบการจัดการเดิมจะถูกย้ายไปที่ระบบใหม่
            </h1>
          </div>

          <div className="space-y-4 max-w-2xl mx-auto px-8">
            <p className="text-gray-300">กรุณากดเข้าใช้งานจากลิงก์ด้านล่าง</p>
          </div>

          <div className="space-y-8">
            <div className="flex justify-center px-8">
              <a
                href={AppConstant.RDOP_URL}
                className="group bg-white text-black p-8 rounded-2xl hover:bg-gray-100 transition-all duration-300 hover:scale-105 hover:shadow-2xl max-w-md w-full"
              >
                <div className="flex items-start justify-between mb-4">
                  <h2 className="text-2xl text-left">สำหรับดีลเลอร์</h2>
                  <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform duration-300" />
                </div>
                <p className="text-gray-600 text-left mb-3">For Dealers</p>
                <p className="text-gray-500 text-sm text-left">
                  ระบบการจัดการสำหรับดีลเลอร์ Rever Dealer Operating System
                </p>
              </a>
            </div>
          </div>

          <p className="text-gray-400 text-center px-8">
            For Internal Rever, please refers to the annoucement or contact{" "}
            <a
              href="mailto:support@balerion.co.th"
              className="text-white hover:underline"
            >
              support@balerion.co.th
            </a>
          </p>
        </div>
      </div>
    </>
  );
};

export default TerminateStaticWebLanding;
